import { Component, OnInit, TemplateRef, ViewChild, HostListener } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { TechnicianService } from '../../services/technician.service';
import { Router } from '@angular/router';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ManagerExecutionService } from '../../services/manager.service';
import { EditBtnRenderer } from 'src/app/edit-action-btn-renderer.component';
import { DeleteBtnRenderer } from 'src/app/delete-action-btn-renderer.component';
import * as moment from 'moment';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TechScoreService } from 'src/app/services/tech-score.service';
import { CommonService } from 'src/app/services/common.service';
import * as XLSX from 'xlsx';
import { MatDialog } from '@angular/material/dialog';
import { differenceInCalendarDays } from 'date-fns';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { PermissionService } from 'src/backend/services/permission.service';
import { DatePipe } from '@angular/common';
import { QRCodeComponent } from 'src/app/screens/qrCodeComponents/qrcode/qrcode.component';
import { ActionEditDeleteViewBtnRendererTechnician } from 'src/app/action-edit-delete-view-btn-renderer-technician.component';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { WOSubtasksDialogComponent } from '../technician-execution/wo-subtasks-dialog.component';
import { SubtasksDialogComponent } from '../preventive-maintenance/schedule-task/subtasks-dialog.component';
import { ExcelExportModule } from 'ag-grid-enterprise/dist/lib/excelExportModule';
import { TechnicianResponsibleDialogComponent } from './technician-responsible-dialog.component';
import { AtStagesNcrComponent } from 'src/app/analytical-tools/at-stages-ncr/at-stages-ncr.component';
import { AnalyticalToolsService } from 'src/app/services/analytical-tools.service';

@Component({
  selector: 'app-technician-execution-list',
  templateUrl: './technician-execution-list.component.html',
  styleUrls: ['./technician-execution-list.component.scss'],
})
export class TechnicianExecutionListComponent implements OnInit {
  private readonly tabletBreakpoint = 1024;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  isEdit: boolean = false;
  IsAssignedToMainTask: boolean = false;
  woList: any = [];
  pmTaskList: any = [];
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('imageViewModal') private imageViewModal!: TemplateRef<any>;
  preventive: string = '';
  blobStorageUrl: string = '';
  user: any;
  spinnerText: string = '';
  selectedFilter: any = 1;
  selected: any;
  dateFilter: any = {};
  technicianTaskId: number;
  technicianColumns: string[] = [
    'Type',
    'WOId',
    'LineId',
    'WOStatus',
    'ScheduledAt',
    'WOType',
    'FailureMode',
    'Priority',
    'SpareParts',
    'SparePartCode',
    'Remark',
    'UploadPicture',
    'StartTime',
    'CompleteTime',
    'SPRequestTime',
    'SPReceivedTime',
    'Remarks',
    'AfterPicture',
    'Actions',
  ];
  woDataSource = new MatTableDataSource();
  pmTaskDataSource = new MatTableDataSource();
  minDate: any;
  maxDate: any;
  userList: any;
  userListPMD: any;
  permisson!: any;
  frameworkComponents: any;
  woColumnDefs!: any[];
  pmColumnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  HeaderForm!: FormGroup;
  GroupList: any = [];
  filteredGroupList: any = [];
  GroupTempList: any = [];
  PlantTempList: any = [];
  techList: any = [];
  PlantList: any;
  filteredPlantList: any;
  frmDate: any;
  woObject: any;
  tDate: any;
  gridOptionsWO: any = {
    defaultColDef: {
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agSetColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
    popupParent: document.querySelector('body'),
  };
  gridOptionsPM: any = {
    defaultColDef: {
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agSetColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
    popupParent: document.querySelector('body'),
  };
  ExportTechnicianWOList: any = [];
  ExportTechnicianPMList: any = [];

  slidesImages: any = [];
  lang: any;
  todayDate = new Date();
  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.todayDate) > 0;
  isInit: boolean = false;
  isAccess = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_ACCESS;
  isWrite = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_CREATE;
  isUpdate = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_UPDATE;
  isDelete = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  qrCodeData: string = '';
  openCount: number;
  closedCount: number;
  completedCount: number;
  delayedCount: number;
  inProgressCount: number;
  reopenCount: number;
  private woSubscription!: Subscription;
  checklists: any[] = [];

  constructor(
    public translater: TranslaterService,
    public translate: TranslateService,
    private fb: FormBuilder,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private technicianService: TechnicianService,
    private router: Router,
    private baseApi: BaseApi,
    public managerExecutionService: ManagerExecutionService,
    public commonservice: CommonService,
    private dialog: MatDialog,
    private analyticalToolsService: AnalyticalToolsService,
    private employeeService: EmployeeService,
    private permissionService: PermissionService,
    private techScore: TechScoreService,
    private PrevConfigurationService: PrevConfigurationService,
  ) {
    let isNotWo = true;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });

    this.frameworkComponents = {
      editRenderer: EditBtnRenderer,
      deleteRenderer: DeleteBtnRenderer,
      actionEditDeleteViewBtnRendererTechnician:
        ActionEditDeleteViewBtnRendererTechnician,
    };
    this.woColumnDefs = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'actionEditDeleteViewBtnRendererTechnician',
        minWidth: 250,
        cellRendererParams: (params: any) => {
          return {
            onClickEdit: this.editRow.bind(this),
            onClickView: this.viewButtonClicked.bind(this),
            onClickQRCode: this.QRRow1.bind(this),
            onClickSubtask: this.openSubtaskDialog.bind(this),
            onClickTechnicianResponsible:
              this.onClickTechnicianResponsible.bind(this),
            onClickViewWorkPermit: this.viewWorkPermitRow.bind(this),
            onClickRCA: this.onClickRCA.bind(this),
            IsAssignedToMainTask: params.data?.IsAssignedToMainTask,
            disabled: params.data?.operExecWo?.techExc?.ID,
            IsWoTab: false,
          };
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      // {
      //   headerName: 'WP#',
      //   field: 'Work Permit',
      //   maxWidth: 100,
      //   cellStyle: function (params: any) {
      //     if (params.value == 'Approved') {
      //       return { color: 'white', backgroundColor: 'green' };
      //     } else if (params.value == 'Pending') {
      //       return { color: 'black', backgroundColor: 'yellow' };
      //     } else if (params.value == 'Rejected') {
      //       return { color: 'white', backgroundColor: 'red' };
      //     } else {
      //       return { color: 'white', backgroundColor: 'grey' };
      //     }
      //   },
      // },
      {
        headerName: 'WO Status',
        maxWidth: 120,
        field: 'Status',
        cellStyle: function (params: any) {
          if (params.value == 'Close' || params.value == 'Complete') {
            return { color: 'white', backgroundColor: 'green' };
          } else if (params.value == 'In Progress') {
            return { color: 'black', backgroundColor: 'orange' };
          } else {
            params.value = params.value == 'ReOpen' ? 'ReOpened' : params.value;
            return { color: 'white', backgroundColor: 'red' };
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Id',
        maxWidth: 100,
        field: 'WOId',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Detail',
        minWidth: 200,
        field: 'woDetails',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'RCA',
        minWidth: 200,
        field: 'rca',
        cellStyle: function (params: any) {
          const atIntegration = params?.data?.operExecWo?.ATIntegration;

          if (atIntegration) {
            const isCompleted =
              atIntegration.ATStatus?.toLowerCase() === 'completed';
            return {
              color: 'blue',
              'text-decoration': 'underline',
              cursor: 'pointer',
              backgroundColor: isCompleted ? '#1de71d' : '#f3f332',
            };
          }
        },
      },
      {
        headerName: 'Manager Remarks',
        field: 'ManagerRemarks',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Technician Remarks',
        field: 'operExecWo.techExc.Remarks',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Spare Parts',
        field: 'operExecWo.SpareParts',
        valueFormatter: (params) =>
          params.value ? 'Required' : 'Not Required',
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Spare Parts Code',
        field: 'SparePartCode',
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Machine Breakdown',
        field: 'operExecWo.MachineBreakdown',
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'WO Type',
        minWidth: 200,
        field: 'woType',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Line/Machine',
        minWidth: 230,
        field: 'LineUnit',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Priority',
        maxWidth: 150,
        field: 'Priority.Name',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      // {
      //   headerName: 'PriorityColor',
      //   maxWidth: 150,
      //   field: 'Priority.Color',
      //   cellRenderer: function (params: any) {
      //     let html = params && params.value ? params.value : '';
      //     return html;
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this),
      // },
      {
        headerName: 'Before Picture',
        maxWidth: 100,
        field: 'beforePicture',
        cellRenderer: function (params: any) {
          let html = '';
          if (
            params &&
            params.data &&
            params.data.operExecWo &&
            params.data.operExecWo.UploadPicture
          ) {
            html = `<img style="width:60px;height:45px ;cursor:pointer" alt="" src="${Constants.BLOB_STORAGE_URL +
              params.data.operExecWo.UploadPicture.split(',')[0]
              }">`;
          } else {
            html = `<img style="width:60px;height:45px ;cursor:pointer" src="assets/images/no-image.png">`;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Raised By',
        minWidth: 200,
        field: 'raisedBy',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Creation Stamp',
        field: 'WOCreatedStamp',
        minWidth: 220,
        valueFormatter: function (params: any) {
          if (params.value) {
            return moment(params.value).format('DD/MM/YYYY hh:mm a');
          } else {
            return;
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: ' Technician StartDate',
        field: 'StartTime',
        minWidth: 220,
        valueFormatter: function (params: any) {
          if (params.value) {
            return moment(params.value).format('DD/MM/YYYY hh:mm a');
          } else {
            return;
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician CompleteDate',
        field: 'CompleteTime',
        minWidth: 220,
        valueFormatter: function (params: any) {
          if (params.value) {
            return moment(params.value).format('DD/MM/YYYY hh:mm a');
          } else {
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Parent WO Id',
        maxWidth: 200,
        field: 'ParentWOId',
        cellRenderer: function (params: any) {
          let html =
            params && params?.data?.operExecWo?.ParentWOId
              ? params?.data?.operExecWo?.ParentWOId
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
    this.pmColumnDefs = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'actionEditDeleteViewBtnRendererTechnician',
        minWidth: 140,
        cellRendererParams: (params: any) => {
          return {
            onClickEdit: this.editRow.bind(this),
            onClickView: this.viewButtonClicked.bind(this),
            onClickSubtask: this.openSubtaskDialog.bind(this),
            IsAssignedToMainTask: params.data?.IsAssignedToMainTask,
            IsWoTab: true,
          };
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Status',
        minWidth: 130,
        field: 'Status',
        cellStyle: function (params: any) {
          if (params.value == 'Done') {
            return { color: 'white', backgroundColor: 'green' };
          } else if (params.value == 'In Progress') {
            return { color: 'black', backgroundColor: 'orange' };
          } else {
            return { color: 'white', backgroundColor: 'red' };
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Line/Machine',
        minWidth: 230,
        field: 'LineUnit',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Parts Code',
        minWidth: 200,
        field: 'spareParts',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Description',
        minWidth: 200,
        field: 'Description',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Started Time',
        minWidth: 180,
        field: 'StartTime',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY HH:mm:ss')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Finished Time',
        minWidth: 180,
        field: 'FinishTime',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY HH:mm:ss')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Result On Date',
        minWidth: 180,
        field: 'ResultOnDate',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY hh:mm a')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Triger At Value',
        minWidth: 150,
        field: 'TrigerAtValue',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Frequency',
        minWidth: 100,
        field: 'Frequency',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Activity Type',
        minWidth: 150,
        field: 'Technology',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      // {
      //   headerName: 'Scheduled Date',
      //   minWidth: 180,
      //   field: 'TaskExpireTime',
      //   cellRenderer: function (params: any) {
      //     let html =
      //       params && params.value
      //         ? moment(params.value).format('DD/MM/YYYY') // hh:mm a
      //         : '';
      //     return html;
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this),
      // },
      {
        headerName: 'Scheduled Date',
        minWidth: 180,
        field: 'TaskExpireTime',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params?.value).add(params?.data?.Task?.Frequency?.Duration ? parseInt(params?.data?.Task?.Frequency?.Duration) - 1 : 0, 'days').format('DD/MM/YYYY') // Adds 10 days
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Upload Picture',
        minWidth: 100,
        field: 'UploadPicture',
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params.data && params.data.UploadPicture) {
            html = `<img style="width:60px;height:45px ;cursor:pointer" alt="" src="${params.data.UploadPicture
              ? Constants.BLOB_STORAGE_URL +
              params.data.UploadPicture.split(',')[0]
              : ''
              }">`;
          } else {
            html = `<img style="width:60px;height:45px ;cursor:pointer" src="assets/images/no-image.png">`;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Checklists',
        minWidth: 250,
        field: 'Task.ChecklistIds',
        filter: true,
        cellRenderer: (params: any) => {
          const checklistIds = params.value?.split(',') || [];
          const checklistMap = new Map(this.checklists.map((c: any) => [String(c.ChecklistId), c.Listname]));

          const checklistNames = checklistIds
            .map((ChecklistId: string) => checklistMap.get(ChecklistId.trim()))
            .filter((Listname: string | undefined) => !!Listname)
            .join(', ');

          return checklistNames || '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      }
    ];
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.getLangWords();
    this.isInit = true;
    this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
    this.selectedFilter = this.technicianService.getTechnicianTabIndex();
    this.user = localStorage.getItem('user');
    this.user = JSON.parse(this.user);
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);
    this;
    this.setPMFilter();
    this.getFilterData();
    const edDT = new Date();
    this.HeaderForm = this.fb.group({
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      Filter: new FormControl(null, [Validators.required]),
      datePicker: new FormControl([stDT, edDT]),
    });
    let techHeaderData = this.technicianService.getTechnicianHeaderData();
    if (techHeaderData) {
      if (
        techHeaderData.FromDate &&
        techHeaderData.FromDate != '' &&
        techHeaderData.ToDate &&
        techHeaderData.ToDate != ''
      )
        this.HeaderForm?.controls['datePicker']?.setValue([
          techHeaderData.FromDate,
          techHeaderData.ToDate,
        ]);
    }
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.getSessionData();
    this.getAllQualityCheckListsNamesPreventiveMiantenance(0);
  }

  getFilterData() {
    this.minDate = this.HeaderForm?.get('datePicker')?.value[0]; // this.dateFilter.From;
    this.maxDate = this.HeaderForm?.get('datePicker')?.value[1]; //this.dateFilter.To;
    this.getUserList();
  }

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        this.spinner.hide();
        this.userList = res;

        this.getTechnicianExecutionList();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }

  getUserName(userId: number) {
    let objFindName = this.userList.find(
      (usr: any) => usr.employeeCode == userId
    );
    if (objFindName) return objFindName?.UserName;
    else if (userId == 100001) return 'Admin';
    else return null;
  }

  getTechnicianExecutionList(): void {
    const data = {
      plantcode: this.plantSession?.plantCode,
      groupId: this.groupSession?.groupCode,
      UserId: this.userSession?.userCode,
      TaskType:
        this.selectedFilter == 0
          ? 'Work Order'
          : this.selectedFilter == 1
            ? 'PM Task'
            : 'Work Order',
      From: this.HeaderForm?.get('datePicker')?.value[0], // this.dateFilter.From,
      To: this.HeaderForm?.get('datePicker')?.value[1], //this.dateFilter.To,
    };

    this.spinner.show();
    this.spinnerText = 'Fetching Technician Data';
    this.technicianService.getTechnicianExecutionList(data).subscribe(
      (res: any) => {
        if (data.TaskType === 'Work Order') {
          this.woList = res.WO;
          this.openCount = 0;
          this.closedCount = 0;
          this.completedCount = 0;
          this.delayedCount = 0;
          this.inProgressCount = 0;
          this.reopenCount = 0;
          this.woList.map((row: any) => {
            row.IsWrite = this.isWrite;
            row.Status =
              row.operExecWo.WOStatus == 1
                ? 'Open'
                : row.operExecWo.WOStatus == 2
                  ? 'Close'
                  : row.operExecWo.WOStatus == 3
                    ? 'Complete'
                    : row.operExecWo.WOStatus == 4
                      ? 'Delay'
                      : row.operExecWo.WOStatus == 6 ? 'Reopen'
                        : 'In Progress'



            switch (row.Status) {
              case 'Open':
                this.openCount++;
                break;
              case 'Close':
                this.closedCount++;
                break;
              case 'Complete':
                this.completedCount++;
                break;
              case 'Delay':
                this.delayedCount++;
                break;
              case 'In Progress':
                this.inProgressCount++;
                break;
              case 'Reopen':
                this.reopenCount++;
                break;
            }

            row.raisedBy = this.getUserName(row.operExecWo?.createdBy);
            row.WOCreatedStamp = row.operExecWo.TimeStamp; //creation Time
            row.woDetails = row.operExecWo?.Remark;
            row.rca = row.operExecWo?.ATIntegration?.HeaderId
              ? `AT-RCA-${row.operExecWo.ATIntegration.HeaderId}`
              : '';
            row.woType = row.operExecWo?.WOType?.Name;
            row.WOId =
              row.operExecWo && row.operExecWo.WOId ? row.operExecWo.WOId : '';
            row.LineUnit =
              row && row.operExecWo && row.operExecWo.line
                ? (row.operExecWo.line ? row.operExecWo.line.plDesc : '') +
                '/' +
                (row.operExecWo.units ? row.operExecWo.units.puDesc : '')
                : '';
            row.Priority = row && row.Priority ? row.Priority : '';
            row.woCreationStamp = row.operExecWo.TimeStamp;
            row.CreatedAt = row.operExecWo.CreatedAt;

            row.ClosedAt = row.operExecWo.ClosedAt;
            if (row.operExecWo.techExc) {
              row.StartTime = row.operExecWo.techExc.StartTime;
              row.CompleteTime = row.operExecWo.techExc.CompleteTime;
            } else {
            }
            (row.woClosedStamp =
              row && row.operExecWo && row.operExecWo.ClosedAt
                ? row.operExecWo.ClosedAt
                : ''),
              (row.IsWrite =
                row.Status == 'Complete' || row.Status == 'Close'
                  ? false
                  : true);
          });
        } else {
          this.pmTaskList = res.WO;
          this.pmTaskList.map((pmTask: any) => {
            if (pmTask.Status === 2) pmTask.Status = 'Expired';
            else
              pmTask.Status =
                pmTask.StartTime && pmTask.FinishTime
                  ? 'Done'
                  : pmTask.StartTime
                    ? 'In Progress'
                    : 'Open';
            pmTask.IsWrite = this.isWrite;
            pmTask.IsWrite =
              pmTask.Status == 'Done'
                ? false
                : pmTask.Status == 'Expired'
                  ? false
                  : true;
            pmTask.LineUnit =
              (pmTask && pmTask.Task && pmTask.Task.line
                ? pmTask.Task.line.plDesc
                : '') +
              '/' +
              (pmTask.Task.units ? pmTask.Task.units.puDesc : '');
            pmTask.spareParts =
              pmTask && pmTask.Task && pmTask.Task.SpareParts
                ? pmTask.Task.SpareParts
                : '';
            pmTask.StartTime =
              pmTask && pmTask.StartTime ? pmTask.StartTime : '';
            pmTask.FinishTime =
              pmTask && pmTask.FinishTime ? pmTask.FinishTime : '';
            pmTask.Frequency =
              pmTask && pmTask.Task && pmTask.Task.Frequency
                ? pmTask.Task.Frequency.Name
                : '';
            pmTask.Technology =
              pmTask && pmTask.Task && pmTask.Task.WOType
                ? pmTask.Task.WOType.Name
                : '';
            pmTask.TaskExpireTime =
              pmTask && pmTask.TaskExpireTime
                ? pmTask.TaskExpireTime
                : new Date().toISOString();
            pmTask.Description =
              pmTask && pmTask.Task.Description ? pmTask.Task.Description : '';
          });
          this.woList = [];
        }
        this.getPaginator();
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error(error?.error?.message);
        this.spinner.hide();
      }
    );
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  searchGroupKey(value: string) {
    let filter = value;
    return this.GroupTempList.filter((grp: any) => {
      let lowerCase = grp.name.toLocaleLowerCase();
      return grp.name.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  setPMFilter() {
    if (this.isInit) {
      const pmFilter = JSON.parse(localStorage.getItem('_pmFilter'));
      if (pmFilter != null && pmFilter != undefined) {
        this.HeaderForm?.get('datePicker').patchValue([
          new Date(pmFilter.FromDate),
          new Date(pmFilter.ToDate),
        ]);
        localStorage.removeItem('_pmFilte');
        this.isInit = false;
      }
    }
  }

  searchPlantKey(value: string) {
    let filter = value;
    return this.PlantTempList.filter((grp: any) => {
      let lowerCase = grp.name.toLocaleLowerCase();
      return grp.name.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.woDataSource.filter = filterValue.trim().toLowerCase();

    if (this.woDataSource.paginator) {
      this.woDataSource.paginator.firstPage();
    }
  }

  getPaginator(): void {
    setTimeout(() => {
      this.woDataSource.paginator = this.paginator;
      this.woDataSource.sort = this.sort;
    }, 100);
  }

  ExportTOExcel() {
    this.ExportTechnicianWOList = [];
    this.ExportTechnicianPMList = [];
    if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order') {
      if (this.woList && this.woList.length) {
        for (const row of this.woList) {
          const ExportData = {
            ['WO Status']:
              row && row.operExecWo && row.operExecWo.WOStatus
                ? row.operExecWo.WOStatus == 1
                  ? 'Open'
                  : row.operExecWo.WOStatus == 2
                    ? 'Close'
                    : row.operExecWo.WOStatus == 3
                      ? 'Complete'
                      : row.operExecWo.WOStatus == 4
                        ? 'Delay'
                        : row.operExecWo.WOStatus == 5
                          ? 'In Progress'
                          : row.operExecWo.WOStatus == 6
                            ? 'ReOpen'
                            : ''
                : '',
            ['WO ID']:
              row && row.operExecWo && row.operExecWo.WOId
                ? row.operExecWo.WOId
                : '',
            ['RCA']:
              row &&
                row.operExecWo.ATIntegration &&
                row.operExecWo.ATIntegration.HeaderId
                ? `AT-RCA-${row.operExecWo.ATIntegration.HeaderId}`
                : '',
            ['WO Creation Date']:
              row && row.operExecWo && row.operExecWo.TimeStamp
                ? moment(row.operExecWo.TimeStamp).format('DD/MM/YYYY hh:mm a')
                : '',
            ['WO Closed Date']:
              row && row.operExecWo && row.operExecWo.ClosedAt
                ? moment(row.operExecWo.ClosedAt).format('DD/MM/YYYY hh:mm a')
                : '',
            ['WO Type']:
              row && row.operExecWo && row.operExecWo.WOType
                ? row.operExecWo.WOType.Name
                : '',
            ['Failure Mode']:
              row && row.operExecWo && row.operExecWo.FailureMode
                ? row.operExecWo.FailureMode.Name
                : '',
            ['Group']:
              row && row.operExecWo && row.operExecWo.Group
                ? row.operExecWo.Group.egDesc
                : '',
            ['Line/Area']: row && row.LineUnit ? row.LineUnit : '',
            ['Spare Parts']:
              row && row.operExecWo && row.operExecWo.SpareParts
                ? 'Required'
                : 'Not Required',
            ['Spare Parts Code']:
              row && row.SparePartCode ? row.SparePartCode : '',
            ['Priority']: row && row.Priority ? row.Priority : '',
            ['Operator Remark']:
              row && row.operExecWo && row.operExecWo.Remark
                ? row.operExecWo.Remark
                : '',
            ['Supervisor Remarks']:
              row && row.ManagerRemarks ? row.ManagerRemarks : '',
            ['Requested By']:
              row && row.operExecWo?.RequestedBy
                ? this.userList.find(
                  (u) =>
                    u.employeeCode === (row?.operExecWo?.RequestedBy || '')
                )?.fullName || ''
                : '',
            ['Technician Status']: row && row.Status ? row.Status : '',
            ['Technician Start Time']:
              row.operExecWo &&
                row.operExecWo.techExc &&
                row.operExecWo.techExc.StartTime
                ? moment(row.operExecWo.techExc.StartTime).format(
                  'DD/MM/YYYY hh:mm a'
                )
                : '',
            ['Technician SP Request Time']:
              row.operExecWo &&
                row.operExecWo.techExc &&
                row.operExecWo.techExc.SPRequestTime
                ? moment(row.operExecWo.techExc.SPRequestTime).format(
                  'DD/MM/YYYY hh:mm a'
                )
                : '',
            ['Technician SP Received Time']:
              row.operExecWo &&
                row.operExecWo.techExc &&
                row.operExecWo.techExc.SPReceivedTime
                ? moment(row.operExecWo.techExc.SPReceivedTime).format(
                  'DD/MM/YYYY hh:mm a'
                )
                : '',
            ['Technician Complete Time']:
              row.operExecWo &&
                row.operExecWo.techExc &&
                row.operExecWo.techExc.CompleteTime
                ? moment(row.operExecWo.techExc.CompleteTime).format(
                  'DD/MM/YYYY hh:mm a'
                )
                : '',
            ['Technician Remarks']:
              row.operExecWo &&
                row.operExecWo.techExc &&
                row.operExecWo.techExc.Remarks
                ? row.operExecWo.techExc.Remarks
                : '',
          };
          this.ExportTechnicianWOList.push(ExportData);
        }
      } else {
        this.ExportTechnicianWOList = [
          {
            ['WO Status']: '',
            ['WO ID']: '',
            ['RCA']: '',
            ['WO Creation Date']: '',
            ['WO Closed Date']: '',
            ['WO Type']: '',
            ['Failure Mode']: '',
            ['Group']: '',
            ['Line/Area']: '',
            ['Spare Parts']: '',
            ['Spare Parts Code']: '',
            ['Priority']: '',
            ['Operator Remark']: '',
            ['Supervisor Remarks']: '',
            ['Requested By']: '',
            ['Technician Status']: '',
            ['Technician Start Time']: '',
            ['Technician SP Request Time']: '',
            ['Technician SP Received Time']: '',
            ['Technician Complete Time']: '',
            ['Technician Remarks']: '',
          },
        ];
      }
      const workBook = XLSX.utils.book_new();
      const WOSheet = XLSX.utils.json_to_sheet(this.ExportTechnicianWOList);
      XLSX.utils.book_append_sheet(workBook, WOSheet, 'Technician Work Order');
      XLSX.writeFile(workBook, `Technician Work Order List.xlsx`);
    } else if (this.selectedFilter == 1 || this.selectedFilter == 'PM Task') {
      if (this.pmTaskList && this.pmTaskList.length) {
        for (const row of this.pmTaskList) {
          const ExportData = {
            ['Group']:
              row && row.Task && row.Task.Group ? row.Task.Group.egDesc : '',
            ['Line/Machine']: row && row.LineUnit ? row.LineUnit : '',
            ['IsAssignedToMainTask']: row && row.IsAssignedToMainTask,
            ['Task Description']:
              row && row.Task && row.Task.Description
                ? row.Task.Description
                : '',
            ['Spare Parts Code']: row && row.spareParts ? row.spareParts : '',
            ['Duration']:
              row && row.Task && row.Task.Duration ? row.Task.Duration : '',
            ['Activity Type']: row && row.Technology ? row.Technology : '',
            ['Frequency']: row && row.Frequency ? row.Frequency : '',
            ['Scheduled Date']:
              row && row.TaskExpireTime
                ? moment(row.TaskExpireTime).format('DD/MM/YYYY hh:mm a')
                : '',
            ['Technician Status']: row && row.Status ? row.Status : '',
            ['Start Time']:
              row && row.StartTime
                ? moment(row.StartTime).format('DD/MM/YYYY hh:mm a')
                : '',
            ['Finish Time']:
              row && row.FinishTime
                ? moment(row.FinishTime).format('DD/MM/YYYY hh:mm a')
                : '',
            ['Technician Remarks']: row && row.Remarks ? row.Remarks : '',
          };
          this.ExportTechnicianPMList.push(ExportData);
        }
      } else {
        this.ExportTechnicianPMList = [
          {
            ['Group']: '',
            ['Line/Machine']: '',
            ['Task Description']: '',
            ['Spare Parts Code']: '',
            ['Duration']: '',
            ['Activity Type']: '',
            ['Frequency']: '',
            ['Scheduled Date']: '',
            ['Technician Status']: '',
            ['Start Time']: '',
            ['Finish Time']: '',
            ['Technician Remarks']: '',
          },
        ];
      }
      const workBook = XLSX.utils.book_new();
      const WOSheet = XLSX.utils.json_to_sheet(this.ExportTechnicianPMList);
      XLSX.utils.book_append_sheet(workBook, WOSheet, 'Technician PM Task');
      XLSX.writeFile(workBook, `Technician PM Task List.xlsx`);
    }
  }
  getSessionData(): void {
    this.userCode = this.userSession.userCode;
  }
  userCode: any;
  onClickTechnicianResponsible(rowdata: any) {
    if (rowdata.WOId > 0) {
      const dialogRef = this.dialog.open(TechnicianResponsibleDialogComponent, {
        width: '600px',
        data: { woId: rowdata.WOId }, // 👈 pass it here
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          console.log('Dialog result:', result);
          this.getTechnicianExecutionList();
        }
      });
    }
  }
  openSubtaskDialog(rowdata: any): void {
    const data: any = {
      isAssignedToMainTask: rowdata?.IsAssignedToMainTask,
      responsibleId: this.userSession?.userCode,
    };

    if (rowdata.WOId > 0) {
      data.technicianExecutionWOID = rowdata?.operExecWo?.techExc?.ID;
      data.WOId = rowdata?.WOId;
    } else {
      data.technicianTaskId = rowdata?.ID;
    }

    this.technicianService.GetSubTaskWorkOrdersByTaskOrWOID(data).subscribe(
      (subtaskData: any) => {
        if (rowdata.WOId > 0) {
          const dialogRef = this.dialog.open(WOSubtasksDialogComponent, {
            width: '1500px',
            height: 'auto',
            data: {
              rowData: subtaskData,
              technicianExecutionWOID: data.technicianExecutionWOID,
              WOId: data.WOId,
              mainTaskStatus: rowdata.Status,
              technicianList: this.userList || [],
              vendorsList: [],
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result && rowdata.operExecWo.WOStatus !== '3') {
              this.getTechnicianExecutionList();
            }
          });
        } else {
          const dialogRef = this.dialog.open(SubtasksDialogComponent, {
            width: '1500px',
            data: {
              rowData: subtaskData,
              isAssignedToMainTask: data.isAssignedToMainTask,
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.getTechnicianExecutionList();
            }
          });
        }
      },
      (error) => { }
    );
  }

  editRow(element: any) {
    if (this.permissionService.isUserHasPermission(this.isUpdate)) {
      element.rowData.isviewButton = false;
      this.technicianService.unit = element.rowData?.Task?.units?.puId ? element.rowData?.Task?.units?.puId : '';
      this.onClickUpdate(element.rowData);
      if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order') {
        this.selectedFilter = 0;
        this.technicianService.setTechnicianTabIndex(this.selectedFilter);
      } else if (this.selectedFilter == 1 || this.selectedFilter == 'PM Task') {
        this.selectedFilter = 1;
        this.technicianService.setTechnicianTabIndex(this.selectedFilter);
      }

      if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order') {
        const data = {
          Group: this.groupSession?.groupCode,
          Plant: this.plantSession?.plantCode,
          FromDate: this.HeaderForm?.get('datePicker')?.value[0],
          ToDate: this.HeaderForm?.get('datePicker')?.value[1],
        };
        this.technicianService.setTechnicianHeaderData(data);
      } else {
        const data = {
          Group: this.groupSession?.groupCode,
          Plant: this.plantSession?.plantCode,
          FromDate: this.HeaderForm?.get('datePicker')?.value[0],
          ToDate: this.HeaderForm?.get('datePicker')?.value[1],
        };
        this.technicianService.setTechnicianHeaderData(data);
        this.editPMTask(element.rowData);
      }
      this.storeFilterData();
    }
  }

  onClickUpdate(element: any): void {
    this.technicianService.setTechnicianValues(element); // element is the WO object
    this.managerExecutionService.setUserData(this.userList);
    this.router.navigate(['/PM/technician-form']);
  }

  // editRow(element: any) {
  //   if (this.permissionService.isUserHasPermission(this.isUpdate)) {
  //     element.rowData.isviewButton = false;
  //     this.onClickUpdate(element.rowData);
  //     if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order') {
  //       this.selectedFilter = 0;
  //       this.technicianService.setTechnicianTabIndex(this.selectedFilter);
  //     } else if (this.selectedFilter == 1 || this.selectedFilter == 'PM Task') {
  //       this.selectedFilter = 1;
  //       this.technicianService.setTechnicianTabIndex(this.selectedFilter);
  //     }

  //     if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order') {
  //       const data = {
  //         Group: this.groupSession?.groupCode,
  //         Plant: this.plantSession?.plantCode,
  //         FromDate: this.HeaderForm?.get('datePicker')?.value[0], //this.dateFilter.From,
  //         ToDate: this.HeaderForm?.get('datePicker')?.value[1], //this.dateFilter.To,
  //       };
  //       this.technicianService.setTechnicianHeaderData(data);
  //     } else {
  //       const data = {
  //         Group: this.groupSession?.groupCode,
  //         Plant: this.plantSession?.plantCode,
  //         FromDate: this.HeaderForm?.get('datePicker')?.value[0], //this.dateFilter.From,
  //         ToDate: this.HeaderForm?.get('datePicker')?.value[1], //this.dateFilter.To,
  //       };
  //       this.technicianService.setTechnicianHeaderData(data);
  //       this.editPMTask(element.rowData);
  //     }
  //     this.storeFilterData();
  //   }
  // }

  // onClickUpdate(element: any): void {
  //   this.technicianService.setTechnicianValues(element);
  //   this.managerExecutionService.setUserData(this.userList);
  //   this.router.navigateByUrl('/PM/technician-form');
  // }
  viewButtonClicked(element: any) {
    if (this.permissionService.isUserHasPermission(this.isAccess)) {
      element.rowData.isviewButton = true;
      this.onClickUpdate(element.rowData);
      if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order') {
        this.selectedFilter = 0;
        this.technicianService.setTechnicianTabIndex(this.selectedFilter);
      } else if (this.selectedFilter == 1 || this.selectedFilter == 'PM Task') {
        this.selectedFilter = 1;
        this.technicianService.setTechnicianTabIndex(this.selectedFilter);
      }

      if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order') {
        const data = {
          Group: this.groupSession?.groupCode,
          Plant: this.plantSession?.plantCode,
          FromDate: this.HeaderForm?.get('datePicker')?.value[0], //this.dateFilter.From,
          ToDate: this.HeaderForm?.get('datePicker')?.value[1], //this.dateFilter.To,
        };
        this.technicianService.setTechnicianHeaderData(data);
      } else {
        const data = {
          Group: this.groupSession?.groupCode,
          Plant: this.plantSession?.plantCode,
          FromDate: this.HeaderForm?.get('datePicker')?.value[0], //this.dateFilter.From,
          ToDate: this.HeaderForm?.get('datePicker')?.value[1], //this.dateFilter.To,
        };
        this.technicianService.setTechnicianHeaderData(data);

        this.editPMTask(element.rowData);
        this.storeFilterData();
      }
    }
  }

  viewWorkPermitRow(element: any) {
    this.toaster.success('WorkPermit', 'WorkPermit Here');
  }

  storeFilterData() {
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      FromDate: this.HeaderForm?.get('datePicker')?.value[0], //this.dateFilter.From,
      ToDate: this.HeaderForm?.get('datePicker')?.value[1], //this.dateFilter.To,
    };
    localStorage.setItem('_pmFilter', JSON.stringify(data));
  }

  editPMTask(element: any) {
    this.technicianService.setTechnicianTaskValues(element);
    this.managerExecutionService.setUserData(this.userList);
    this.router.navigate(['/PM/edit-tech-task']);
  }

  onFilterChanged(event: any) {
    if (this.selectedFilter == 0 || this.selectedFilter == 'Work Order')
      this.gridOptionsWO.api.setQuickFilter(event.value);
    else if (this.selectedFilter == 1 || this.selectedFilter == 'PM Task')
      this.gridOptionsPM.api.setQuickFilter(event.value);
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.refreshResponsiveGrids();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.refreshResponsiveGrids();
  }

  private refreshResponsiveGrids(): void {
    const activeApi =
      this.selectedFilter == 0 || this.selectedFilter == 'Work Order'
        ? this.gridOptionsWO?.api
        : this.gridOptionsPM?.api;

    if (activeApi) {
      activeApi.refreshHeader();
      activeApi.resetRowHeights();
    }
  }

  isTabletViewport(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= this.tabletBreakpoint;
  }

  cellClicked(params: any): void {

    const col = params.colDef.field;
    if (col == 'beforePicture' || col == 'UploadPicture') {
      if (col == 'beforePicture')
        this.slidesImages =
          params.data.operExecWo && params.data.operExecWo.UploadPicture
            ? params.data.operExecWo.UploadPicture.split(',')
            : [];
      else if (col == 'UploadPicture')
        this.slidesImages = params.data.UploadPicture
          ? params.data.UploadPicture.split(',')
          : [];

      if (this.slidesImages && this.slidesImages.length) {
        let dialogRef = this.dialog.open(this.imageViewModal, {
          height: '90%',
          width: '90%',
        });
        dialogRef.afterClosed().subscribe((result) => { });
      }
    }
    if (col == 'rca') {
      if (params?.value !== '') {
        const headerId = params?.data?.operExecWo?.ATIntegration?.HeaderId ?? 0;
        this.analyticalToolsService.setHeaderId(headerId);
        const dialogRef = this.dialog.open(AtStagesNcrComponent, {
          height: '100%',
          width: '100%',
          panelClass: 'full-screen-modal-RCA',

          data: {
            InitProbStatement: params.data.woDetails,
            ncrIdDesc: params.data.woDetails,
            tableId: params.data.WOId,
            moduleId: 9,
            patchForm: headerId != 0 ? true : false,
            patchHeader: true,
            Group: this.groupSession.groupCode,
            Plant: this.plantSession.plantCode,
            headerId: headerId,
            isView: true,
          },
        });
        dialogRef.afterClosed().subscribe((data) => {
          this.analyticalToolsService.setHeaderId(0);
          this.getTechnicianExecutionList();
        });
      }
    }
  }
  oncloseimg() {
    this.dialog.closeAll();
  }

  // QRRow1(element: any) {
  //   if(!this.permissionService.isUserHasPermission(this.isAccess)){
  //     this.toaster.error('Error', "You donot have the permission to view");
  //     return;
  //   }

  //   const datePipe = new DatePipe('en-US');

  //   const qrData = {
  //     woId: element.rowData?.WOId,
  //     woDetails: element.rowData?.operExecWo?.Remark,
  //     line : element.rowData?.operExecWo?.line?.plDesc,
  //     sparePart: element.rowData?.operExecWo?.SpareParts === 0 ? 'Not Required' : 'Required',
  //     woType: element.rowData?.operExecWo?.WOType?.Name,
  //     machine: element.rowData?.operExecWo?.units?.puDesc,
  //     assembly: element.rowData?.operExecWo?.assembly?.assblyDesc,
  //     subAssembly: element.rowData?.operExecWo?.subAssembly?.sAsblyDesc,
  //     component: element.rowData?.operExecWo?.component?.componentName,
  //     failureMode:element.rowData?.operExecWo?.FailureMode?.Name,
  //     woStatus: element.rowData?.operExecWo?.WOStatus,
  //     createdBy: element.rowData?.CreatedByName,
  //     createdAt: element.rowData?.CreatedAt ? datePipe.transform(element.rowData.CreatedAt, 'dd/MM/yyyy') : null,
  //   }
  //   this.qrCodeData = JSON.stringify(qrData);
  //   const key = {
  //     data: this.qrCodeData,
  //     fileName: 'QR Code'
  //   }
  //   this.dialog.open(QRCodeComponent, {
  //     panelClass: 'custom-dialog-container',
  //     width: 'auto',
  //     height: 'auto',
  //     disableClose: true,
  //     data: key
  //   });
  // }

  onClickRCA(params: any): void {
    const headerId = params?.operExecWo?.ATIntegration?.HeaderId ?? 0;

    this.analyticalToolsService.setHeaderId(headerId);

    const dialogRef = this.dialog.open(AtStagesNcrComponent, {
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal-RCA',

      data: {
        InitProbStatement: params.woDetails,
        ncrIdDesc: params.woDetails,
        tableId: params.WOId,
        moduleId: 9,
        patchForm: headerId !== 0 ? true : false,
        patchHeader: true,
        Group: this.groupSession.groupCode,
        Plant: this.plantSession.plantCode,
        headerId: headerId,
        hideTabs: false,
        isCreate: true,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.analyticalToolsService.setHeaderId(0);
      this.getTechnicianExecutionList();
    });
  }

  QRRow1(element: any) {
    this.spinner.show();
    const getImage = {
      plantId: this.plantSession?.plantCode,
      woId: parseInt(element.rowData?.WOId),
    };
    this.techScore.getTechnicianImageAndName(getImage).subscribe(
      (res: any) => {
        this.spinner.hide();
        const datePipe = new DatePipe('en-US');

        const qrData = {
          woId: element.rowData?.WOId,
          woDetails: element.rowData?.operExecWo?.Remark,
          line: element.rowData?.operExecWo?.line?.plDesc,
          sparePart:
            element.rowData?.operExecWo?.SpareParts === 0
              ? 'Not Required'
              : 'Required',
          woType: element.rowData?.operExecWo?.WOType?.Name,
          machine: element.rowData?.operExecWo?.units?.puDesc,
          assembly: element.rowData?.operExecWo?.assembly?.assblyDesc,
          subAssembly: element.rowData?.operExecWo?.subAssembly?.sAsblyDesc,
          component: element.rowData?.operExecWo?.component?.componentName,
          failureMode: element.rowData?.operExecWo?.FailureMode?.Name,
          priority: element.rowData?.Priority?.Name,
          priorityColor: element.rowData?.Priority?.Color,
          woStatus: element.rowData?.operExecWo?.WOStatus,
          createdBy: element.rowData?.operExecWo?.CreatedByName,
          createdAt: element.rowData?.CreatedAt
            ? datePipe.transform(element.rowData.CreatedAt, 'dd/MM/yyyy')
            : null,
        };
        this.qrCodeData = JSON.stringify(qrData);
        const key = {
          data: this.qrCodeData,
          fileName: 'QR Code',
          technicianList: res ? res : '',
          isTechnician: true,
          // techId: JSON.parse(localStorage.user).UserId,
          techId: this.userSession?.userCode,
        };
        this.dialog.open(QRCodeComponent, {
          panelClass: 'custom-dialog-container',
          minWidth: '600px',
          height: '90%',
          disableClose: true,
          data: key,
        });
      },
      (error) => {
        this.spinner.hide();
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  getAllQualityCheckListsNamesPreventiveMiantenance(unitId: any): void {
    this.spinner.show();
    const payload = {
      PlantCode: this.plantSession?.plantCode,
      UnitId: unitId
    }
    this.PrevConfigurationService.getAllQualityCheckListsNamesPreventiveMiantenance(payload)
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          this.checklists = data;
        },
        error: (error) => {
          this.spinner.hide();
          this.toaster.error('Error', error.ErrorMessage);
        }
      });
  }
}
